<div class="notification-settings">
  <div class="row mb-3 align-items-center">
    <label class="col-sm-1 col-form-label" for="notificationSettingsRole">
      {{ 'Settings::Notifications:Role' | abpLocalization }}
    </label>
    <div class="col-sm-4">
      <ca-role-selector
        id="notificationSettingsRole"
        [cls]="'fill-width'"
        [multiple]="false"
        [removePagination]="true"
        [ngModel]="selectedRole"
        (ngModelChange)="onRoleChanged($event)"
        placeholder="{{ 'CA::PleaseSelectWithThreeDots' | abpLocalization }}"></ca-role-selector>
    </div>
  </div>

  <hr />

  <div class="text-muted mb-3" *ngIf="!isRoleSelected">
    {{ 'Settings::Notifications:SelectRole' | abpLocalization }}
  </div>

  <div class="d-flex justify-content-center py-4" *ngIf="isRoleSelected && isLoading">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  </div>

  <div class="text-danger mb-3" *ngIf="showLoadError">
    {{ 'AbpUi::DefaultErrorMessage' | abpLocalization }}
  </div>

  <div class="text-muted mb-3" *ngIf="showEmptyState">
    {{ 'CA::NoDataFound' | abpLocalization }}
  </div>

  <ng-container *ngIf="showMatrix">
    <ca-notification-channel-matrix
      [categories]="categories"
      [disabled]="isMatrixDisabled"
      (changed)="onChanged()"></ca-notification-channel-matrix>

    <div class="d-flex gap-2 mt-3">
      <button
        type="button"
        class="btn btn-primary mt-3"
        [disabled]="isSaveDisabled"
        (click)="onSave()">
        <i class="fas fa-save me-1" *ngIf="!isSaving"></i>
        <i class="fas fa-spinner fa-spin me-1" *ngIf="isSaving"></i>
        <span>{{ 'CA::Save' | abpLocalization }}</span>
      </button>
      <button
        type="button"
        class="btn ca-btn-neutral mt-3"
        [disabled]="isCancelDisabled"
        (click)="onCancel()">
        {{ 'AbpUi::Cancel' | abpLocalization }}
      </button>
    </div>
  </ng-container>
</div>
